export const getCurrentYearIdFromLS = (): number | null => {
  const year = localStorage.getItem('currentYearId');

  return year && Number.isFinite(+year) ? +year : null;
};

export const getCurrentYearFromLS = (): number | null => {
  const year = localStorage.getItem('currentYear');

  return year && Number.isFinite(+year) ? +year : null;
};

export const getCurrentYearFrozenFromLS = (): boolean => {
  const year = localStorage.getItem('currentYearFrozen');
  return year === 'true';
};

export const getCurrentYearGoalFrozenFromLS = (): boolean => {
  const year = localStorage.getItem('currentYearGoalFrozen');
  return year === 'true';
};

export const getReadOnly = () => {
  const isYearsPage = window.location.pathname === '/years';
  const role = localStorage.getItem('role');
  const isFrozenYear = getCurrentYearFrozenFromLS();

  return (isFrozenYear && !isYearsPage) || role === 'viewer';
};

export const notChangeGoal = () => {
  const role = localStorage.getItem('role');
  const isFrozenGoalYear = getCurrentYearGoalFrozenFromLS();
  return isFrozenGoalYear && role === 'manager';
};

export const appendYearIdParam = (url: string) => {
  const hasParams = url.includes('?');
  const yearId = getCurrentYearIdFromLS();

  let extendedUrl = url;

  if (yearId) {
    extendedUrl = hasParams
      ? `${extendedUrl}&year=${yearId}`
      : `${extendedUrl}?year=${yearId}`;
  }

  return extendedUrl;
};
